import type * as Types from '@__graphql__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProductDetailsFromUrlQueryVariables = Types.Exact<{
  url_key?: Types.InputMaybe<Types.Scalars['String']>;
  languages?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']>> | Types.InputMaybe<Types.Scalars['String']>>;
}>;


export type ProductDetailsFromUrlQuery = { content?: { pricing_pages: Array<{ layout?: Array<{ item?: { __typename: 'pricing_pages_multi_layout' } | { __typename: 'pricing_pages_single_layout', product?: { sku: string, title?: string | null, links?: Array<{ products_links_id?: { link_type?: string | null, id: string, translations?: Array<{ title?: string | null, url?: string | null, languages_code?: { code: string } | null } | null> | null } | null } | null> | null } | null } | null } | null> | null }> } | null };

export type ItemFragment = { id: number, sku: string, name: string, description?: string | null, detail_page_url?: string | null, image_url: string, full_price: { value: number, currency: string } };

export type CustomerProductUpgradeQueryVariables = Types.Exact<{
  sku: Types.Scalars['String'];
  currentPage: Types.Scalars['Int'];
  pageSize: Types.Scalars['Int'];
  sortOrders?: Types.InputMaybe<Array<Types.SortOrder> | Types.SortOrder>;
}>;


export type CustomerProductUpgradeQuery = { userV2?: { __typename: 'AnonymousUser' } | { __typename: 'AuthenticatedUser', id: string, product_upgrade?: { current_product: string, included_products?: { page_info: { page_size: number, current_page: number, has_next_page: boolean }, items: Array<ItemFragment> } | null, prices?: { full_price: { value: number, currency: string } } | null } | null } | null };

export const ItemFragmentDoc = gql`
    fragment Item on Magento2_RestAPI_Product {
  id
  sku
  name
  description
  detail_page_url
  image_url
  full_price {
    value
    currency
  }
}
    `;
export const ProductDetailsFromUrlDocument = gql`
    query ProductDetailsFromUrl($url_key: String, $languages: [String]) {
  content {
    pricing_pages(filter: {url_key: {_eq: $url_key}}) {
      layout {
        item {
          __typename
          ... on pricing_pages_single_layout {
            product {
              sku
              title
              links {
                products_links_id {
                  link_type
                  id
                  translations(filter: {languages_code: {code: {_in: $languages}}}) {
                    title
                    url
                    languages_code {
                      code
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProductDetailsFromUrlQuery__
 *
 * To run a query within a React component, call `useProductDetailsFromUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDetailsFromUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDetailsFromUrlQuery({
 *   variables: {
 *      url_key: // value for 'url_key'
 *      languages: // value for 'languages'
 *   },
 * });
 */
export function useProductDetailsFromUrlQuery(baseOptions?: Apollo.QueryHookOptions<ProductDetailsFromUrlQuery, ProductDetailsFromUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductDetailsFromUrlQuery, ProductDetailsFromUrlQueryVariables>(ProductDetailsFromUrlDocument, options);
      }
export function useProductDetailsFromUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductDetailsFromUrlQuery, ProductDetailsFromUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductDetailsFromUrlQuery, ProductDetailsFromUrlQueryVariables>(ProductDetailsFromUrlDocument, options);
        }
export type ProductDetailsFromUrlQueryHookResult = ReturnType<typeof useProductDetailsFromUrlQuery>;
export type ProductDetailsFromUrlLazyQueryHookResult = ReturnType<typeof useProductDetailsFromUrlLazyQuery>;
export type ProductDetailsFromUrlQueryResult = Apollo.QueryResult<ProductDetailsFromUrlQuery, ProductDetailsFromUrlQueryVariables>;
export const CustomerProductUpgradeDocument = gql`
    query CustomerProductUpgrade($sku: String!, $currentPage: Int!, $pageSize: Int!, $sortOrders: [SortOrder!]) {
  userV2 {
    __typename
    ... on AuthenticatedUser {
      id
      product_upgrade(sku: $sku) {
        included_products(
          pageSize: $pageSize
          currentPage: $currentPage
          sortOrders: $sortOrders
        ) {
          page_info {
            page_size
            current_page
            has_next_page
          }
          items {
            ...Item
          }
        }
        current_product
        prices {
          full_price {
            value
            currency
          }
        }
      }
    }
  }
}
    ${ItemFragmentDoc}`;

/**
 * __useCustomerProductUpgradeQuery__
 *
 * To run a query within a React component, call `useCustomerProductUpgradeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerProductUpgradeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerProductUpgradeQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *      currentPage: // value for 'currentPage'
 *      pageSize: // value for 'pageSize'
 *      sortOrders: // value for 'sortOrders'
 *   },
 * });
 */
export function useCustomerProductUpgradeQuery(baseOptions: Apollo.QueryHookOptions<CustomerProductUpgradeQuery, CustomerProductUpgradeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerProductUpgradeQuery, CustomerProductUpgradeQueryVariables>(CustomerProductUpgradeDocument, options);
      }
export function useCustomerProductUpgradeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerProductUpgradeQuery, CustomerProductUpgradeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerProductUpgradeQuery, CustomerProductUpgradeQueryVariables>(CustomerProductUpgradeDocument, options);
        }
export type CustomerProductUpgradeQueryHookResult = ReturnType<typeof useCustomerProductUpgradeQuery>;
export type CustomerProductUpgradeLazyQueryHookResult = ReturnType<typeof useCustomerProductUpgradeLazyQuery>;
export type CustomerProductUpgradeQueryResult = Apollo.QueryResult<CustomerProductUpgradeQuery, CustomerProductUpgradeQueryVariables>;